<template>
  <!-- 话务管理-规则配置 -->
  <basic-container>
    <el-tabs v-model="tabKey" type="card" :before-leave="beforeLeaveTab">
      <el-tab-pane label="基础配置" name="settings"> </el-tab-pane>
      <el-tab-pane label="语音/铃声库" name="library"></el-tab-pane>
    </el-tabs>
    <div :style="'height:' + (bodyHeight - 200) + 'px; overflow: scroll;'">
      <Settings v-if="tabKey == 'settings'"></Settings>
      <Library v-else-if="tabKey == 'library'"></Library>
    </div>
  </basic-container>
</template>

<script>
import Settings from './settings';
import Library from './library';

export default {
  components: {
    Settings,
    Library,
  },
  data() {
    return {
      tabKey: 'settings', // 选项卡标识
    };
  },
  created() {},
  methods: {
    /* 切换选项卡时的校验 */
    beforeLeaveTab(activeName, oldActiveName) {
      /* if (oldActiveName == 'settings') {
        return this.$confirm('确认离开当前页面？', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });
      } */
      return true;
    },
  },
};
</script>

<style lang="scss" scoped></style>
